import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminBooks,
  getAdminBookChapters,
} from "../../api/admin/book.api";

/* ============================================================
   FETCH BOOKS
============================================================ */

export const fetchBooks = createAsyncThunk(
  "admin/book/fetchBooks",
  async (courseCategoryId, { rejectWithValue }) => {
    try {
      const res = await getAdminBooks(courseCategoryId);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch books."
      );
    }
  }
);

/* ============================================================
   FETCH BOOK CHAPTERS
============================================================ */

export const fetchBookChapters = createAsyncThunk(
  "admin/book/fetchBookChapters",
  async (bookId, { rejectWithValue }) => {
    try {
      const res = await getAdminBookChapters(bookId);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch book chapters."
      );
    }
  }
);